module.exports = __webpack_public_path__ + "static/media/Logo_porsche.ae9511e5.png";